module.exports = __webpack_public_path__ + "img/network1.b704e846.png";